import React, { Component } from "react";
import { Input } from "@revvsales/components";
import { ErrorMessages } from "../../../../commonComponents";

// eslint-disable-next-line react/prefer-stateless-function
class CommonDynamicFields extends Component {
  constructor(props) {
    super(props);
    this.textInput = null;
  }

  componentDidMount() {
    if (this.textInput) {
      this.textInput.focus();
    }
  }

  render() {
    return (
      <React.Fragment>
        <div
          className="revv-form-items"
          data-test="commondynamicfields-revv-form-items-fieldname">
          <span
            className="revvform-label"
            data-test="commondynamicfields-revvform-label-fieldname">
            Field name{" "}
            <span
              className="requiredwitherr-input"
              data-test="commondynamicfields-requiredwitherr-input-fieldname">
              *
            </span>
          </span>
          <Input
            autoFocus
            id="FIELD NAME"
            data-test="commondynamicfields-fieldname-input"
            name="field_name"
            type="text"
            value={this.props.values && this.props.values.field_name}
            // eslint-disable-next-line no-return-assign
            inputRef={elem => (this.textInput = elem)}
            placeholder="Enter field name"
            className={`${
              this.props.messages.field_name !== undefined &&
              this.props.messages.field_name.required !== ""
                ? "danger-border"
                : ""
            }`}
            onChange={value => this.props.handleChange(value)}
            onBlur={value => this.props.handleBlur(value)}
            required
          />
          {this.props.messages.field_name && (
            <ErrorMessages messages={this.props.messages.field_name.required} />
          )}
        </div>
        <div
          className="revv-form-items"
          data-test="commondynamicfields-revv-form-items-fielddescription">
          <span
            className="revvform-label"
            data-test="commondynamicfields-revvform-label-fielddescription">
            Field description{" "}
            <span
              className="requiredwitherr-input"
              data-test="commondynamicfields-requiredwitherr-input-fielddescription">
              *
            </span>
          </span>
          <Input
            id="FIELD DESCRIPTION"
            data-test="commondynamicfields-fielddescription-input"
            type="text"
            name="description"
            value={this.props.values && this.props.values.description}
            placeholder="Enter field description"
            className={`${
              this.props.messages.description !== undefined &&
              this.props.messages.description.required !== ""
                ? "danger-border"
                : ""
            }`}
            onBlur={value => this.props.handleBlur(value)}
            onChange={value => this.props.handleChange(value)}
            required
          />
          {this.props.messages.description && (
            <ErrorMessages
              messages={this.props.messages.description.required}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default CommonDynamicFields;



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/CommonDynamicFields.js